export function logError(error: Error | unknown, cause?: Error) {
  if (error instanceof Error && cause instanceof Error) {
    error.message += `, Caused by: ${cause.toString()}`
    error.stack += '\nCaused by: ' + cause.stack
  }

  console.error(error)
}
